"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _ = require("_");

function _default(actionTypeMap) {
  var uniques = {};
  Object.keys(actionTypeMap).forEach(function (key) {
    uniques[key] = (0, _.uniqueId)(actionTypeMap[key] || key);
  });
  return uniques;
}

module.exports = exports.default;